import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { SOCIAL } from "../data/content";

export default function Privacy() {
  return (
    <main className="pt-16" data-testid="privacy-page">
      <Seo title="Privacy" description="How Laugh at L.A. and Providence Film Group handle your information." />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 py-20">
        <Reveal>
          <h1 className="font-display text-5xl text-white">Privacy</h1>
          <div className="mt-8 space-y-6 text-gray-300 leading-relaxed text-sm sm:text-base">
            <p><strong className="text-white">What we collect.</strong> If you join the list, we store your email address and, if you share them, your first name, city, and interests. If you write to us through the contact or screener forms, we store your name, email, and message so we can reply.</p>
            <p><strong className="text-white">How we use it.</strong> Only to send the updates you asked for and to respond to your inquiry. We do not sell or share your information with third parties for their marketing.</p>
            <p><strong className="text-white">Viewing codes.</strong> Screener viewing codes are validated on our servers. Failed attempts are rate-limited for security, and codes can be revoked at any time.</p>
            <p><strong className="text-white">Your choices.</strong> You can unsubscribe from the list or ask us to delete your information at any time by emailing <a className="text-[#F59E0B] link-gold" href={`mailto:${SOCIAL.emailShow}`}>{SOCIAL.emailShow}</a>.</p>
            <p><strong className="text-white">Questions.</strong> Write to <a className="text-[#F59E0B] link-gold" href={`mailto:${SOCIAL.emailPfg}`}>{SOCIAL.emailPfg}</a>.</p>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
